import { normalizeRole } from "../utils/rbac";

export const API_URL = (process.env.REACT_APP_API_URL || "https://devicehub.studds.com")
  .trim()
  .replace(/\/+$/, "");

export const apiFetch = async (endpoint: string, options: RequestInit = {}) => {
  const token = localStorage.getItem("token");

  const headers = new Headers(options.headers);

  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  const cleanEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  const targetUrl = `${API_URL}${cleanEndpoint}`;

  console.log(`[apiFetch] ${options.method || "GET"} -> ${targetUrl}`);

  const response = await fetch(targetUrl, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    window.location.href = "/login";
    return response;
  }

  // Check if backend returned the user's current live role
  const rawRole = response.headers.get("x-user-role");
  if (rawRole) {
    const liveRole = normalizeRole(rawRole);
    const currentStoredRole = localStorage.getItem("userRole");
    if (liveRole !== currentStoredRole) {
      localStorage.setItem("userRole", liveRole);
      window.dispatchEvent(
        new CustomEvent("roleChanged", { detail: { role: liveRole } })
      );
    }
  }

  return response;
};
